import IncButton from 'components/inc-button/inc-button.component';
import { useTranslation } from 'react-i18next';

const ContinueWithPassword = ({ send, isNewUser }) => {
  const { t } = useTranslation();
  return (
    <IncButton
      sx={{ mt: 1 }}
      fullWidth
      onClick={() => send(isNewUser ? 'REGISTER' : 'LOGIN')}
      data-testid="ContinueWithPassword.IncButton"
    >
      {t('passwordless.continueWithPassword')}
    </IncButton>
  );
};

export default ContinueWithPassword;
